export default __webpack_public_path__ + "static/media/blog-right.a2d6a0b1.png";